import {
  LogStatoPosizionePersonalizzazioneOrdineType,
  OrdineDetailType,
  PersonalizzazioneOrdineType,
  StatoPosizionePersonalizzazioneChoices,
} from '@utils/types'
import _ from 'lodash'

const getPosizioniPersonalizzazione = (personalizzazione?: any) =>
  personalizzazione?.posizioniPersonalizzazioneOrdine || personalizzazione?.posizioni || []

const getPosizioneFirma = (posizione: any, index: number) => {
  const configurazione = posizione?.configurazione || posizione

  return [
    Number(posizione?.numero ?? index + 1),
    configurazione?.tecnica?.codice || '',
    configurazione?.posizione?.codice || '',
    configurazione?.numeroColoriPosizione?.codice || configurazione?.numeroColori?.codice || '',
    configurazione?.dimensione?.codice || '',
  ].join('|')
}

// Cerca nell'ordine fornitore la personalizzazione equivalente a quella cliente
// confrontando nome lavorazione e configurazione delle posizioni.
export const getPersonalizzazioneFornitore = (
  ordineFornitore?: OrdineDetailType | null,
  personalizzazioneCliente?: PersonalizzazioneOrdineType | null
) => {
  if (!ordineFornitore || !personalizzazioneCliente) return null

  const firmaCliente = [
    personalizzazioneCliente.nomeLavorazione || '',
    ...getPosizioniPersonalizzazione(personalizzazioneCliente).map(getPosizioneFirma).sort(),
  ].join('::')

  return (
    (ordineFornitore.personalizzazioniOrdine || []).find((personalizzazioneFornitore) => {
      const firmaFornitore = [
        personalizzazioneFornitore.nomeLavorazione || '',
        ...getPosizioniPersonalizzazione(personalizzazioneFornitore).map(getPosizioneFirma).sort(),
      ].join('::')

      return firmaCliente === firmaFornitore
    }) || null
  )
}

export const OrderBy = ({ Array, value, setState, setSort, prevArray, sortFilter }) => {
  const getSort: () => string = () => {
    switch (sortFilter) {
      case null:
        return 'asc'
      case 'asc':
        return 'desc'
      case 'desc':
        return null
      default:
        return null
    }
  }
  const sort = getSort()
  if (sort !== null) {
    const new_ordered_array = _.orderBy(Array, [value.toString()], [sort.toString()])
    setState && setState([...new_ordered_array])
    setSort && setSort((prevalue) => ({ ...prevalue, [value.toString()]: sort.toString() }))
  } else {
    setSort && setSort((prevalue) => ({ ...prevalue, [value.toString()]: null }))
    setState && prevArray && setState([...prevArray])
  }
}

export const getUltimoLogPosizione = (
  logs: LogStatoPosizionePersonalizzazioneOrdineType[] | undefined,
  stato: StatoPosizionePersonalizzazioneChoices
) =>
  logs
    ?.filter((log) => log.stato === stato)
    .reduce<LogStatoPosizionePersonalizzazioneOrdineType | undefined>(
      (ultimo, log) => (!ultimo || (log.created || '') >= (ultimo.created || '') ? log : ultimo),
      undefined
    )
